export default __webpack_public_path__ + "static/media/b7.9945dc10.jpg";